import React, { Component } from "react";
import {
    Grid,
    Row,
    Col,
    FormGroup,
    InputGroup,
    ControlLabel,
    FormControl
} from "react-bootstrap";

import ReactLoading from "react-loading";

import Iframe from 'react-iframe';

import { auth, db, storage } from "firedb/firebase";

import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";

import { DefaultCompanyLogoURL, DefaultCompanyBGURL } from "variables/Config";

import './phone.css';
import './iframe.css';
import './input.css';
import './upload-img-buttons.css';

function ConvertCompanyBonusToPersent(d) {
    return Math.floor((d * 100)).toString() || "";
};

function ConvertCompanyBonusFromPersent(d) {
    return parseFloat(d)/100;
};

const init_state = {
    Loading     : true,
    PictureUploading : false,

    UserEmail  : '',
    UserName  : '',
    CompanyUID  : '',
    CompanyName : '',
    CompanyCategory : '',
    CompanySite : '',
    CompanyVK : '',
    CompanyFB : '',
    CompanyInst : '',
    CompanyAddress : '',
    CompanyDescription : '',
    CompanyBonus : '',

    UserEmailValid : null,
    UserNameValid : null,
    CompanyNameValid : null,
    CompanyAddressValid : null,
    CompanyDescriptionValid : null,
    CompanyCategoryValid : null,
    CompanySiteValid : null,
    CompanyVKValid : null,
    CompanyFBValid : null,
    CompanyInstValid : null,
    CompanyBonusValid : null,

    UserNameChanged : false,
    CompanyNameChanged : false,
    CompanyDescriptionChanged : false,
    CompanyCategoryChanged : false,
    CompanySiteChanged : false,
    CompanyVKChanged : false,
    CompanyFBChanged : false,
    CompanyInstChanged : false,
    CompanyBonusChanged : false,

    CompanyLogoChanged : false,
    CompanyBGChanged : false,

    CompanyLogoPath : null,
    CompnayBGPath : null,
    CompanyLogo : null,
    CompanyBG : null,

    iframeURL : ""
};

function CleanURLImage(url) {
    var urlapi = require('url');
    var urlLogo = urlapi.parse(url);

    var r = urlLogo.protocol + "//" + urlLogo.hostname + urlLogo.pathname;

    return r;
}

class UserProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {...init_state};

        this.onChangeName = this.onChangeName.bind(this);
        this.onChangeCompanyName = this.onChangeCompanyName.bind(this);
        this.onChangeCompanyAddress = this.onChangeCompanyAddress.bind(this);
        this.onChangeCompanyDescription = this.onChangeCompanyDescription.bind(this);
        this.onChangeCompanyCategory = this.onChangeCompanyCategory.bind(this);
        this.onChangeCompanySite = this.onChangeCompanySite.bind(this);
        this.onChangeCompanyVK = this.onChangeCompanyVK.bind(this);
        this.onChangeCompanyFB = this.onChangeCompanyFB.bind(this);
        this.onChangeCompanyInst = this.onChangeCompanyInst.bind(this);
        this.onSelectLogo = this.onSelectLogo.bind(this);
        this.onSelectBG = this.onSelectBG.bind(this);
        this.onChangeCompanyBonus = this.onChangeCompanyBonus.bind(this);

        this.reloadIFrame = this.reloadIFrame.bind(this);
    }

    componentWillMount() {
        this.setState({PictureUploading : false});

        // console.log("User Firebase UID :" + auth.currentUser.uid);
        this.setState({UserEmail : auth.currentUser.email || ""});
        this.setState({UserName : auth.currentUser.displayName || ""});

        // console.log(auth.currentUser);

        db.ref('admin/' + auth.currentUser.uid).once('value').then(snapshot => {
            // console.log("user data from firebase");
            // console.log(snapshot.val());
            this.setState({CompanyUID : snapshot.val().company});

            db.ref('company/' + this.state.CompanyUID).once('value').then(snapshot => {
                // console.log("company data from firebase");
                // console.log(snapshot.val());

                this.setState({CompanyName : snapshot.val().name || ""});
                this.setState({CompanyDescription : snapshot.val().description || ""});
                this.setState({CompanyCategory : snapshot.val().category || ""});
                this.setState({CompanySite : snapshot.val().site || ""});
                this.setState({CompanyVK : snapshot.val().vk || ""});
                this.setState({CompanyFB : snapshot.val().fb || ""});
                this.setState({CompanyInst : snapshot.val().instagram || ""});
                this.setState({CompanyBonus : ConvertCompanyBonusToPersent(snapshot.val().discount)});

                
                //FIXME : add default pictures 
                this.setState({CompanyLogoPath : CleanURLImage(snapshot.val().logo || DefaultCompanyLogoURL)});
                    // || "https://firebasestorage.googleapis.com/v0/b/dropcard-test.appspot.com/o/bg%2Fdefault-logo.png")  });

                this.setState({CompanyBGPath : CleanURLImage(snapshot.val().background || DefaultCompanyBGURL)});
                    // || "https://firebasestorage.googleapis.com/v0/b/dropcard-test.appspot.com/o/bg%2Fdefaul-bg.png") });

                this.setState({Loading : false});

                this.reloadIFrame();
            });
        });
    }

    onClickPublished = (event) => {
        var changedCompanyProperty = {};

        if(this.state.CompanyNameChanged) { changedCompanyProperty["name"] = this.state.CompanyName; }
        if(this.state.CompanyDescriptionChanged) { changedCompanyProperty["description"] = this.state.CompanyDescription; }
        if(this.state.CompanyCategoryChanged) { changedCompanyProperty["category"] = this.state.CompanyCategory; }
        if(this.state.CompanySiteChanged) { changedCompanyProperty["site"] = this.state.CompanySite; }
        if(this.state.CompanyVKChanged) { changedCompanyProperty["vk"] = this.state.CompanyVK; }
        if(this.state.CompanyFBChanged) { changedCompanyProperty["fb"] = this.state.CompanyFB; }
        if(this.state.CompanyInstChanged) { changedCompanyProperty["instagram"] = this.state.CompanyInst; }
        if(this.state.CompanyBonusChanged) { changedCompanyProperty["discount"] = 
            ConvertCompanyBonusFromPersent(this.state.CompanyBonus); }
        if(this.state.CompanyLogoChanged) { changedCompanyProperty["logo"] = this.state.CompanyLogoPath; }
        if(this.state.CompanyBGChanged) { changedCompanyProperty["background"] = this.state.CompanyBGPath; }

        if(Object.keys(changedCompanyProperty).length !== 0) { 
            db.ref('company/' + this.state.CompanyUID).update(changedCompanyProperty, 
                (error) => {
                    if(error !== null) { 
                        // console.log("Firebase return error during update company data");
                        // console.log(error);

                        if(this.state.CompanyNameChanged) { this.setState({CompanyNameValid : "error"}); }
                        if(this.state.CompanyDescriptionChanged) { this.setState({CompanyDescriptionValid : "error"}); }
                        if(this.state.CompanyCategoryChanged) { this.setState({CompanyCategoryValid : "error"}); }
                        if(this.state.CompanySiteChanged) { this.setState({CompanySiteValid : "error"}); }
                        if(this.state.CompanyVKChanged) { this.setState({CompanyVKValid : "error"}); }
                        if(this.state.CompanyFBChanged) { this.setState({CompanyFBValid : "error"}); }
                        if(this.state.CompanyInstChanged) { this.setState({CompanyInstValid : "error"}); }
                        if(this.state.CompanyBonusChanged) { this.setState({CompanyBonusValid : "error"}); }

                    }
                }).then(snapshot => {
                    console.log("Update database success");
                    if(this.state.CompanyNameChanged) {
                        this.setState({CompanyNameValid : "success"});
                        this.setState({CompanyNameChanged : false});
                    }
                    if(this.state.CompanyDescriptionChanged) {
                        this.setState({CompanyDescriptionValid : "success"});
                        this.setState({CompanyDescriptionChanged : false});
                    }
                    if(this.state.CompanyCategoryChanged) {
                        this.setState({CompanyCategoryValid : "success"});
                        this.setState({CompanyCategoryChanged : false});
                    }
                    if(this.state.CompanySiteChanged) {
                        this.setState({CompanySiteValid : "success"});
                        this.setState({CompanySiteChanged : false});
                    }
                    if(this.state.CompanyVKChanged) {
                        this.setState({CompanyVKValid : "success"});
                        this.setState({CompanyVKChanged : false});
                    }
                    if(this.state.CompanyFBChanged) {
                        this.setState({CompanyFBValid : "success"});
                        this.setState({CompanyFBChanged : false});
                    }
                    if(this.state.CompanyInstChanged) {
                        this.setState({CompanyInstValid : "success"});
                        this.setState({CompanyInstChanged : false});
                    }
                    if(this.state.CompanyBonusChanged) {
                        this.setState({CompanyBonusValid : "success"});
                        this.setState({CompanyBonusChanged : false});
                    }
                    this.setState({CompanyLogoChanged : false});
                    this.setState({CompanyBGChanged : false});

                    console.log("Update database success - finish");


                });
        }

        console.log("Now check user changed name");

        if(this.state.UserNameChanged) {
            auth.currentUser.updateProfile({displayName : this.state.UserName}).then( () => {
                this.setState({UserNameValid : "success"});
                this.setState({UserNameChanged : false});
            }).catch((error) => {
                this.setState({UserNameValid : "error"});
            });
        }

    }

    onSelectLogo(event) {
        this.setState({PictureUploading : true});

        var filename = "logo/" + this.state.CompanyUID + "-" +  
            Math.round(+new Date()/1000) + "-" + event.target.files[0].name;

        storage.ref(filename)
            .put(event.target.files[0])
            .then( (snapshot) => {
                snapshot.ref.getDownloadURL().then( (url) => {
                    this.setState({CompanyLogoChanged : true});
                    this.setState({PictureUploading : false});
                    this.setState({CompanyLogoPath : CleanURLImage(url)});

                    this.reloadIFrame();
                });
            });            
    }

    onSelectBG(event) {
        this.setState({PictureUploading : true});
        var filename = "bg/" + this.state.CompanyUID + "-" +  
            Math.round(+new Date()/1000) + "-" + event.target.files[0].name;

        storage.ref(filename)
            .put(event.target.files[0])
            .then( (snapshot) => {
                snapshot.ref.getDownloadURL().then( (url) => {
                    this.setState({CompanyBGChanged : true});
                    this.setState({PictureUploading : false});
                    this.setState({CompanyBGPath : CleanURLImage(url)});

                    this.reloadIFrame();
                });
            });
    }

    onChangeName(event) {
        this.setState({UserName : event.target.value});
        this.setState({UserNameChanged : true});
        this.setState({UserNameValid : "warning"});
    }

    onChangeCompanyName(event) {
        this.setState({CompanyName : event.target.value});
        this.setState({CompanyNameChanged : true});
        this.setState({CompanyNameValid : "warning"});
    }

    onChangeCompanyCategory(event) {
        this.setState({CompanyCategory : event.target.value});
        this.setState({CompanyCategoryChanged : true});
        this.setState({CompanyCategoryValid : "warning"});
    }

    onChangeCompanySite(event) {
        this.setState({CompanySite : event.target.value});
        this.setState({CompanySiteChanged : true});
        this.setState({CompanySiteValid : "warning"});
    }

    onChangeCompanyVK(event) {
        this.setState({CompanyVK : event.target.value});
        this.setState({CompanyVKChanged : true});
        this.setState({CompanyVKValid : "warning"});
    }

    onChangeCompanyFB(event) {
        this.setState({CompanyFB : event.target.value});
        this.setState({CompanyFBChanged : true});
        this.setState({CompanyFBValid : "warning"});
    }

    onChangeCompanyInst(event) {
        this.setState({CompanyInst : event.target.value});
        this.setState({CompanyInstChanged : true});
        this.setState({CompanyInstValid : "warning"});
    }

    onChangeCompanyAddress(event) {
        this.setState({CompanyAddress : event.target.value});
    }

    onChangeCompanyDescription(event) {
        // this.setState({CompanyDescription : event.target.value.replace(/\n/g,"<br />")});
        this.setState({CompanyDescription : event.target.value});
        this.setState({CompanyDescriptionChanged : true});
        this.setState({CompanyDescriptionValid : "warning"});
    }

    onChangeCompanyBonus(event) {
        this.setState({CompanyBonus : event.target.value});
        this.setState({CompanyBonusChanged : true});
        this.setState({CompanyBonusValid : "warning"});
    }

    reloadIFrame() {
        this.setState({ iframeURL : "https://demo-ui.nakopi.club?name="  + this.state.CompanyName
            + "&category=" + this.state.CompanyCategory
            + "&description=" + this.state.CompanyDescription.replace(/\n/g,"<br />")
            + "&address=" + this.state.CompanyAddress
            + "&logo=" + this.state.CompanyLogoPath + "&bg=" + this.state.CompanyBGPath});
    }

    render() {

        return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={8}>
              <Card
                title="Настройки профиля"
                content={
                <div>

                    <Row>             
                        <div className="col-md-5">
                        <FormGroup>
                            <ControlLabel>Почтовый адрес</ControlLabel>
                            <FormControl
                                type="text"
                                bsClass="form-control"
                                placeholder="Email"
                                value={this.state.UserEmail}
                                disabled="true"
                            />
                        </FormGroup>
                        </div>

                        <div className="col-md-7">
                        <FormGroup validationState={this.state.UserNameValid}>
                            <ControlLabel>ФИО</ControlLabel>
                            <FormControl
                                type="text"
                                bsClass="form-control"
                                placeholder="Как нам к Вам обращаться"
                                disabled={this.state.Loading}

                                value={this.state.UserName}
                                onChange={this.onChangeName}
                                onBlur={this.reloadIFrame}
                            />
                        </FormGroup>
                        </div>                        
                    </Row>

                    <Row>
                    <div className="col-md-5">
                        <FormGroup validationState={this.state.CompanyNameValid} >
                            <ControlLabel>Название компании</ControlLabel>
                            <FormControl
                                type="text"
                                bsClass="form-control"
                                placeholder="Название, которое будет видно Вашим клиентам"
                                disabled={this.state.Loading}

                                value={this.state.CompanyName}
                                onChange={this.onChangeCompanyName}
                                onBlur={this.reloadIFrame}
                            />
                        </FormGroup>                    
                    </div>

                    <div className="col-md-7">
                        <FormGroup validationState={this.state.CompanySiteValid} >
                            <ControlLabel>Сайт Вашей компании</ControlLabel>
                            <FormControl
                                type="text"
                                bsClass="form-control"
                                placeholder="https://nakopi.club"
                                disabled={this.state.Loading}

                                value={this.state.CompanySite}
                                onChange={this.onChangeCompanySite}
                                onBlur={this.reloadIFrame}
                            />
                        </FormGroup>                    
                    </div>
                    </Row>

                    <Row>
                    <div className="col-md-6">
                        <FormGroup validationState={this.state.CompanyCategoryValid} >
                            <ControlLabel>Категория Вашей компании</ControlLabel>
                            <FormControl
                                type="text"
                                bsClass="form-control"
                                placeholder="Кафе, студия или, может, магазин цветов"
                                disabled={this.state.Loading}

                                value={this.state.CompanyCategory}
                                onChange={this.onChangeCompanyCategory}
                                onBlur={this.reloadIFrame}
                            />
                        </FormGroup>                    
                    </div>

                    </Row>

                    <Row>
                    <div className="col-md-4 bonus-area">
                        <FormGroup validationState={this.state.CompanyBonusValid}>
                            <ControlLabel>Бонус</ControlLabel>
                            <InputGroup >
                                <FormControl
                                    type="text"
                                    placeholder="10"
                                    bsClass="form-control"
                                    disabled={this.state.Loading}

                                    value={this.state.CompanyBonus}
                                    onChange={this.onChangeCompanyBonus}
                                    onBlur={this.reloadIFrame}
                                />
                                <InputGroup.Addon>%</InputGroup.Addon>
                            </InputGroup>
                        </FormGroup>
                    </div>

                    <div className="col-md-8 text-muted">
                        <br /><small>Бонус определяет количество процентов от суммы чека, которое будет конвертированно в баллы клиента.</small>
                        <br /><small>Размер бонуса может составлять от 1 до 20 %.</small>
                    </div>
                    </Row>

                    <Row>
                    <div className="col-md-4">
                        <FormGroup validationState={this.state.CompanyVKValid} >
                            <ControlLabel>vkontakte</ControlLabel>
                            <FormControl
                                type="text"
                                bsClass="form-control"
                                placeholder="https://vk.com/nakopiclub"
                                disabled={this.state.Loading}

                                value={this.state.CompanyVK}
                                onChange={this.onChangeCompanyVK}
                                onBlur={this.reloadIFrame}
                            />
                        </FormGroup>                    
                    </div>

                    <div className="col-md-4">
                        <FormGroup validationState={this.state.CompanyFBValid} >
                            <ControlLabel>facebook</ControlLabel>
                            <FormControl
                                type="text"
                                bsClass="form-control"
                                placeholder="https://facebook.com/nakopi.club"
                                disabled={this.state.Loading}

                                value={this.state.CompanyFB}
                                onChange={this.onChangeCompanyFB}
                                onBlur={this.reloadIFrame}
                            />
                        </FormGroup>                    
                    </div>
                    <div className="col-md-4">
                        <FormGroup validationState={this.state.CompanyInstValid} >
                            <ControlLabel>instagram</ControlLabel>
                            <FormControl
                                type="text"
                                bsClass="form-control"
                                placeholder="https://instagram.com/nakopiclub"
                                disabled={this.state.Loading}

                                value={this.state.CompanyInst}
                                onChange={this.onChangeCompanyInst}
                                onBlur={this.reloadIFrame}
                            />
                        </FormGroup>                    
                    </div>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <FormGroup controlId="formControlsTextarea" validationState={this.state.CompanyDescriptionValid}>
                          <ControlLabel >Описание </ControlLabel>
                            <small className="text-muted"><small>&emsp;Здесь можно использовать HTML для форматирования</small></small>
                          <FormControl
                            rows="5"
                            componentClass="textarea"
                            bsClass="form-control"
                            placeholder="Опишите Вашу компанию для того, чтобы люди знали больше о Вас."
                            disabled={this.state.Loading}

                            value={this.state.CompanyDescription}
                            onChange={this.onChangeCompanyDescription}
                            onBlur={this.reloadIFrame}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Button bsStyle="info" pullRight fill type="submit" 
                        data-toggle="tooltip" data-placement="top" 
                        title="После публикации все изменения будут видны Вашим клиентам"

                        onClick={this.onClickPublished}
                        disabled={ !(this.state.UserNameChanged || this.state.CompanyNameChanged 
                                    || this.state.CompanyDescriptionChanged || this.state.CompanyCategoryChanged
                                    || this.state.CompanySiteChanged || this.state.CompanyVKChanged
                                    || this.state.CompanyFBChanged || this.state.CompanyInstChanged 
                                    || this.state.CompanyBonusChanged || this.state.CompanyLogoChanged 
                                    || this.state.CompanyBGChanged )}
                    >
                      Опубликовать
                    </Button>
                    <div className="clearfix" />
                  </div>
              }
            />


            </Col>

            <Col md={4}>
                <div className="phone-container">
                    <Iframe url={this.state.iframeURL}
                        width="375px"
                        height="667px"
                        id="myId"
                        className="myClassname"
                        display="initial"
                        position="relative"
                        allowFullScreen 
                    />
                </div>
                {/*https://bootsnipp.com/snippets/featured/input-file-popover-preview-image*/}

                <div className="container-bttn-logo-bg" >
                    <div style={{display: this.state.CompanyLogoChanged || this.state.CompanyBGChanged ? 'block' : 'none' }}>Изменения еще не сохранены. Не забудьте нажать кнопку "Опубликовать" после загрузки логотипа и/или фона</div>
                    <div style={{display: this.state.PictureUploading ? 'none' : 'block' }} >
                    <FormGroup>
                        <div className="box">
                            <input type="file" id="file-1" className="inputfile inputfile-1" accept="image/*,image/jpeg"
                                style={{display: 'none'}}

                                onChange={this.onSelectLogo}
                            />
                            <label htmlFor="file-1">
                                <svg width="20" height="17" viewBox="0 0 20 17">
                                    <path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"/>
                                </svg> 
                                <span>Логотип</span>
                            </label>
                        </div>

                    </FormGroup>
                    <FormGroup>
                        <div className="box">
                            <input type="file" id="file-2" className="inputfile inputfile-1" accept="image/*,image/jpeg"
                                style={{display: 'none'}} 

                                onChange={this.onSelectBG}
                            />
                            <label htmlFor="file-2">
                                <svg width="20" height="17" viewBox="0 0 20 17">
                                <path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"/>
                                </svg> 
                                <span>Фон</span>
                            </label>
                        </div>
                    </FormGroup>
                    </div>

                    <div className="container-bttn-loader" style={{display: this.state.PictureUploading ? 'block' : 'none' }}>
                        <ReactLoading type="spin" color="rgb(231, 120, 23)" />
                        {/*<ReactLoading type="spinningBubbles" color="#555" />             */}
                    </div>


                </div>
            </Col>
            </Row>
        </Grid>
      </div>
        );
    }
}


export default UserProfile;



// WEBPACK FOOTER //
// ./src/views/UserProfile/UserProfile.jsx